























































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { vxm } from '@/store'
import { Watch } from 'vue-property-decorator'
import DateField from '@/components/inputs/DateField.vue'

@Component({
  components: {
    DateField,
  },
})
export default class List extends Vue {
  private isReady = false
  private loading = false
  private selectedRegister: number | null = null
  private startDate: string | null = null
  private endDate: string | null = null
  private minReceiptNumber: number | null = null
  private maxReceiptNumber: number | null = null
  private registers: Array<Record<string, unknown>> = []
  private receipts: Array<Record<string, unknown>> = []
  private perPage: number = 300
  private currentPage: number = 1
  private totalPages: number = 1
  private totalItems: number = 0

  get registerOptions() {
    return [
      { number: null, name: this.$t('All registers') },
      ...this.registers
    ]
  }

  private created() {
    this.setDefaultDates()
    this.loadRegisters(() => {
      this.onRouteChange()
    })
  }

  private setDefaultDates() {
    const today = new Date()

    this.endDate = today.toISOString().split('T')[0]
    this.startDate = today.toISOString().split('T')[0]
    this.selectedRegister = null // Default to "All registers"
  }

  @Watch('currentPage')
  private onPageChange() {
    this.doLoadReceipts()
  }

  @Watch('$route', { deep: true })
  private onRouteChange() {
    if (this.$route.query.registerNumber !== undefined) {
      this.selectedRegister = parseInt(this.$route.query.registerNumber as string)
    }
    if (this.$route.query.startDate !== undefined) {
      this.startDate = this.$route.query.startDate as string
    }
    if (this.$route.query.endDate !== undefined) {
      this.endDate = this.$route.query.endDate as string
    }
    if (this.$route.query.minReceiptNumber !== undefined) {
      this.minReceiptNumber = parseInt(this.$route.query.minReceiptNumber as string)
    }
    if (this.$route.query.maxReceiptNumber !== undefined) {
      this.maxReceiptNumber = parseInt(this.$route.query.maxReceiptNumber as string)
    }
  }

  private loadRegisters(callback: () => void) {
    this.$axios
      .get('/v4/site/payment/cash-registers')
      .then((response) => {
        this.registers = response.data.data
        this.isReady = true
        callback()
      })
      .catch((err) => {
        vxm.alert.onAxiosError(err, this.$t('Failed to load list of cash registers'))
      })
  }

  private loadReceipts() {
    this.currentPage = 1
    this.doLoadReceipts()
  }

  private doLoadReceipts() {
    /*
    if (!this.startDate || !this.endDate) {
      alert(this.$t('Please select both start and end dates'))
      return
    }

    const start = new Date(this.startDate)
    const end = new Date(this.endDate)
    const diffTime = Math.abs(end.getTime() - start.getTime())
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    if (diffDays > 62) { // ~2 months
      alert(this.$t('Maximum allowed period is 2 months'))
      return
    }
    */

    this.loading = true
    this.receipts = []
    const params = new URLSearchParams()

    if (this.selectedRegister) {
      params.append('registerNumber', this.selectedRegister.toString())
    }
    if (this.startDate) {
      params.append('minReceiptDate', this.startDate)
    }
    if (this.endDate) {
      params.append('maxReceiptDate', this.endDate)
    }
    if (this.minReceiptNumber) {
      params.append('minReceiptNumber', this.minReceiptNumber.toString())
    }
    if (this.maxReceiptNumber) {
      params.append('maxReceiptNumber', this.maxReceiptNumber.toString())
    }
    params.append('perPage', this.perPage.toString())
    params.append('page', this.currentPage.toString())

    this.$axios
      .get(`/v4/site/economy/receipts?${params.toString()}`)
      .then((response) => {
        this.receipts = response.data.data
        if (response.data.meta) {
          this.currentPage = response.data.meta.currentPage || 1
          this.totalPages = response.data.meta.lastPage || 1
          this.totalItems = response.data.meta.totalItemsCount || 0
        }
        this.loading = false
      })
      .catch((err) => {
        this.loading = false
        vxm.alert.onAxiosError(err, this.$t('Failed to load receipts'))
      })
  }

  private formatDate(dateString: string): string {
    return new Date(dateString).toISOString().split('T')[0]
  }

  private formatAmount(amount: string | number): string {
    const num = typeof amount === 'string' ? parseFloat(amount) : amount
    return new Intl.NumberFormat('sv-SE', {
      style: 'currency',
      currency: 'SEK'
    }).format(num).replace(',', '.').replace(/\s/g, ' ')
  }

  private getReceiptType(receipt: Record<string, unknown>): string {
    if (receipt.creditedReceiptNumber) {
      return this.$t('Refund')
    }
    return this.$t('Sale')
  }

  private formatDiscount(line: Record<string, unknown>): string {
    const discountValue = parseFloat(line.discountValue as string)
    if (discountValue === 0) {
      return '-'
    }
    if (line.discountType === 'Percent') {
      return `${discountValue}%`
    }
    return this.formatAmount(discountValue)
  }

  private calculateLineNet(line: Record<string, unknown>): number {
    const quantity = parseFloat(line.quantity as string)
    const unitPrice = parseFloat(line.unitPrice as string) // ex VAT
    const discountValue = parseFloat(line.discountValue as string)

    let netTotal = quantity * unitPrice

    if (line.discountType === 'Percent') {
      netTotal = netTotal * (1 - discountValue / 100)
    } else {
      netTotal = netTotal - discountValue
    }

    return netTotal
  }

  private calculateLineVat(line: Record<string, unknown>): number {
    const netAmount = this.calculateLineNet(line)
    const vatPercent = parseFloat(line.vatPercent as string)
    return netAmount * (vatPercent / 100)
  }

  private calculateLineGross(line: Record<string, unknown>): number {
    const netAmount = this.calculateLineNet(line)
    const vatAmount = this.calculateLineVat(line)
    return netAmount + vatAmount
  }

  private getPaymentType(paymentExtension: string): string {
    switch (paymentExtension) {
      case 'pay_cash_pos':
        return this.$t('Cash')
      case 'pay_card_pos':
        return this.$t('Card')
      case 'pay_bank_transfer':
        return this.$t('Bank Transfer')
      default:
        return paymentExtension || this.$t('Unknown')
    }
  }
}
